var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFilters(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M7.27499 11.6611H1.357C0.607997 11.6611 0 12.2585 0 12.9943C0 13.7292 0.607997 14.3275 1.357 14.3275H7.27499C8.02397 14.3275 8.63201 13.7292 8.63201 12.9943C8.63201 12.2585 8.02397 11.6611 7.27499 11.6611Z",
    fill: "#EAF1F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M18.0002 3.04072C18.0002 2.30584 17.3921 1.7085 16.6441 1.7085H10.7262C9.97718 1.7085 9.36914 2.30584 9.36914 3.04072C9.36914 3.77658 9.97718 4.37392 10.7262 4.37392H16.6441C17.3921 4.37392 18.0002 3.77658 18.0002 3.04072Z",
    fill: "#EAF1F0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.18998 3.04071C6.18998 4.72072 4.80499 6.08241 3.09499 6.08241C1.38599 6.08241 0 4.72072 0 3.04071C0 1.36169 1.38599 0 3.09499 0C4.80499 0 6.18998 1.36169 6.18998 3.04071Z",
    fill: "#F7D169"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0006 12.9591C18.0006 14.6382 16.6156 15.9999 14.9056 15.9999C13.1965 15.9999 11.8105 14.6382 11.8105 12.9591C11.8105 11.2791 13.1965 9.91748 14.9056 9.91748C16.6156 9.91748 18.0006 11.2791 18.0006 12.9591Z",
    fill: "#F7D169"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilters);
export default __webpack_public_path__ + "static/media/filters.ceb521bc3858d949e2d407ead9b48ada.svg";
export { ForwardRef as ReactComponent };